"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToArray = void 0;
const core_1 = require("flow-connect/core");
class ToArray extends core_1.Node {
    constructor() {
        super();
    }
    setupIO(options) {
        this.addTerminals(options.noOfInputs && options.noOfInputs > 0
            ? new Array(options.noOfInputs)
                .fill(null)
                .map((_, index) => ({ type: core_1.TerminalType.IN, name: "In " + (index + 1), dataType: "any" }))
            : [{ type: core_1.TerminalType.IN, name: "In 1", dataType: "any" }]);
        this.addTerminal({ type: core_1.TerminalType.OUT, name: "out", dataType: "array" });
    }
    created(options) {
        const { width = 100, name = "To Array", style = {} } = options;
        this.width = width;
        this.name = name;
        this.style = Object.assign({ rowHeight: 10 }, style);
        this.setupUI();
        this.setupListeners();
    }
    process(inputs) {
        this.setOutputs(0, [...inputs]);
    }
    setupUI() {
        this.addButton = this.createUI("core/button", { text: "Add", style: { grow: 0.5 } });
        this.ui.append(this.addButton);
    }
    setupListeners() {
        this.addButton.on("click", () => this.addTerminal({ type: core_1.TerminalType.IN, dataType: "any", name: "In " + this.inputs.length + 1 }));
    }
    serialize(persist) {
        const _super = Object.create(null, {
            serialize: { get: () => super.serialize }
        });
        return __awaiter(this, void 0, void 0, function* () {
            const serializedNode = (yield _super.serialize.call(this, persist));
            serializedNode.noOfInputs = this.inputs.length;
            return serializedNode;
        });
    }
}
exports.ToArray = ToArray;
